<wk-icon-plus-sprite-pds3 />
<wk-icon-trash-sprite-pds3 />

<div class="wk-cm__card-panel__notes__container fancy-scrollbar-newUI fancy-scrollbar-small">
    @let notes = notesService.notes();
    @for (note of notes; track note.id) {
        <card-pds3 flowClass="borderless" mode="container">
            <div class="wk-cm__card-panel__note">
                <p class="wk-cm__card-panel__note-text">{{ note.text }}</p>
                <div class="wk-cm__card-panel__note-meta">{{ note.userName }} - {{ note.formattedDate }}</div>
            </div>
            <icon-pds3 class="wk-cm__card-panel__note-delete" name="wk-icon-trash" (click)="noteToDelete.set(note)" />
        </card-pds3>
    }
    @if (notes.length === 0) {
        <div class="wk-cm__card-panel__notes__empty">
            <wk-icon-no-records-sprite-pds3 />
            <icon-pds3 name="wk-icon-no-records" />
            <p>{{ "iFirmTaxNotes.NoNotes" | translate }}</p>
        </div>
    }
</div>

<div class="cg3-flex-row cg3-flex-center-y cg3-gap">
    <link-field-pds3 type="standalone" size="medium">
        <a href="javascript:void(0)" flow-id="standalone-large-link" (click)="addModal.set(true)">
            <icon-pds3 name="wk-icon-plus" flowClass="link-with-icon" [isDecorativeOnly]="true" />
            {{ "iFirmTaxNotes.AddANote" | translate }}
        </a>
    </link-field-pds3>
</div>

@if (addModal()) {
    <wk-modal title="iFirmTaxNotes.AddANote" (closeModal)="addModal.set(false)" [confirmAction]="confirmAddAction()">
        <text-field-pds3>
            <textarea #addNote type="text" placeholder="{{ placeholder() | translate }}" rows="3"></textarea>
        </text-field-pds3>
    </wk-modal>
}

@if (noteToDelete()) {
    @let note = noteToDelete();
    @if (note) {
        <wk-modal title="iFirmTaxNotes.DeleteNoteTitle" (closeModal)="noteToDelete.set(null)" [confirmAction]="confirmDeleteAction()">
            <p>
                {{ "iFirmTaxNotes.ConfirmDelete1" | wkTranslate }} <strong>{{ note.userName }}</strong>
                {{ "iFirmTaxNotes.ConfirmDelete2" | wkTranslate }}
                <strong>{{ note.formattedDate }}</strong>
            </p>
        </wk-modal>
    }
}
